import Type5 from "./option";

export default Type5;
